/**
 * The shipped level roster (spec 6.1: 2 worlds × 4 levels + tutorial).
 * Order here IS the progression order shown in Level Select.
 */
import type { LevelFile } from "../track/types";
import { TUTORIAL, W1_L1, W1_L2, W1_L3, W1_L4 } from "./world1";
import { W2_L1, W2_L2, W2_L3, W2_L4 } from "./world2";
import { W3_L1, W3_L2, W3_L3, W3_L4 } from "./world3";

export { TUTORIAL };

/** Campaign levels in progression order (tutorial excluded). */
export const CAMPAIGN: LevelFile[] = [
  W1_L1, W1_L2, W1_L3, W1_L4,
  W2_L1, W2_L2, W2_L3, W2_L4,
  W3_L1, W3_L2, W3_L3, W3_L4,
];

export const ALL_LEVELS: LevelFile[] = [TUTORIAL, ...CAMPAIGN];

export function levelById(id: string): LevelFile | undefined {
  return ALL_LEVELS.find((l) => l.id === id);
}

export function nextLevelId(id: string): string | undefined {
  const i = CAMPAIGN.findIndex((l) => l.id === id);
  return i >= 0 && i + 1 < CAMPAIGN.length ? CAMPAIGN[i + 1]!.id : undefined;
}

export const WORLD_NAMES: Record<number, string> = {
  1: "Ion Coast",
  2: "Redline",
  3: "Duskfall Cascade",
};
